import { ManualDasConfigurationDtoToEntity } from "src/app/features/ManualDasConfiguration/services/mappers/ManualDasConfigurationDtoToEntity";
import type { ManualDasConfigurationDto } from "src/app/features/ManualDasConfiguration/types/ManualDasConfigurationDto";
import type { ManualDasConfigurationEntity } from "src/app/features/ManualDasConfiguration/types/ManualDasConfigurationEntity";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const ManualDasConfigurationTableDtoMapper = (
    input: Readonly<ManualDasConfigurationDto>,
): ResourcePageEntity<ManualDasConfigurationEntity> => {
    return {
        list: ManualDasConfigurationDtoToEntity(input) || [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
